import { fromDotObject } from "../../../utils/dotObject";
import mergeDocumentData from "../../../utils/mergeDocumentData";

import articleDeliveryStatuses from "../constants/articleDeliveryStatuses";
import articleDeliveryTypes from "../constants/articleDeliveryTypes";
import getDeliveryStatusByPriority from "../getDeliveryStatusByPriority";

export function updateArticleDeliveryStatus(article, data) {
	const { channels, channelIds } = mergeDocumentData(article, data);

	const deliveryStatusData = Object.values(articleDeliveryTypes).reduce((acc, deliveryType) => {
		const channelDeliveryStatuses = Object.entries(channels || {})
			.filter(
				([channelId]) =>
					channelIds?.includes(channelId) &&
					(!channels?.[channelId].deliveryTypes ||
						channels?.[channelId].deliveryTypes.includes(deliveryType)),
			)
			.map(([_, { delivery }]) => delivery?.[deliveryType]?.status);

		const channelStatusByPriority = getDeliveryStatusByPriority(channelDeliveryStatuses);

		return {
			...acc,
			[`delivery.${deliveryType}.status`]: !channelStatusByPriority
				? articleDeliveryStatuses.DELIVERY_NOT_STARTED
				: channelStatusByPriority,
		};
	}, {});

	return fromDotObject({
		...data,
		...deliveryStatusData,
		"delivery.status": getDeliveryStatusByPriority(Object.values(deliveryStatusData)),
	});
}
